import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Components/Form";
import toast from "react-hot-toast";
import Header from "../../../../Components/Header";
import {
  create_home_slider,
  get_home_slider,
  update_home_slider,
} from "../../../../Controllers/Home/Sliders";
import forms from "../../../../Data/Forms/Home/Sliders/forms";
import headers from "../../../../Data/Forms/Home/Sliders/headers";
import Loadercomponent from "../../../../Components/Loader";
import AddButton from "../../../../Components/Buttons/add";
import RemoveButton from "../../../../Components/Buttons/delete";
import { convert_to_file } from "../../../../Controllers/Global";

const HomeSliderForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const slider = id
        ? await update_home_slider({ ...data?.data, id: id })
        : await create_home_slider(data?.data);

      if (slider?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(slider?.message);
        setButtonLoader(false);
      } else {
        toast?.error(slider?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = async (slider) => {
    let image = slider?.image ? slider?.image : "";
    let file = await convert_to_file(image);
    let title = slider?.title ? slider?.title : "";
    let description = slider?.description ? slider?.description : "";
    let button = slider?.button ? slider?.button : "";
    let status = slider?.status ? slider?.status : 0;

    forms[0].options[0].form.value = [file];
    forms[0].options[1].form.value = title;
    forms[0].options[2].form.value = description;
    forms[0].options[3].form.value = button;
    forms[0].options[4].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const slider = await get_home_slider(data);
      if (slider?.status) {
        handleData(slider?.data);
      } else {
        toast?.error(slider?.message);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default HomeSliderForm;
